module.exports = __webpack_public_path__ + "static/img/card.a10855d8.png";